import { DateField, Field, Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps, SitecoreContextValue } from 'lib/ComponentProps';

import CalendarIconSvg from 'public/icons/calendar.svg';

import styles from './LastUpdated.module.css';

type LastUpdatedProps = ComponentProps & {
	fields: {
		__Updated: Field<string>;
		LastUpdated: Field<string>;
	};
};

export default function LastUpdated(props: LastUpdatedProps): JSX.Element {
	const { sitecoreContext } = useSitecoreContext<SitecoreContextValue>();

	return (
		<div className={`${styles.lastUpdatedContainer} maxWidth`}>
			<div title={sitecoreContext.dictionary.lastUpdatedDate ? sitecoreContext.dictionary.lastUpdatedDate : ''}>
				<div className={styles.lastUpdatedWrapper}>
					<CalendarIconSvg className={styles.lastUpdatedIcon} />
					<Text field={{ value: sitecoreContext.dictionary.lastUpdatedDate }} />
					<>&nbsp;</>
					<DateField
						field={{ value: props.fields.__Updated ?? props.fields.LastUpdated }}
						render={(date: Date) => date && date.toLocaleDateString('en-GB')}
					/>
				</div>
			</div>
		</div>
	);
}
